import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import App from './App'
import store from './store'

const routes = [
  {
    path: '/',
    name: 'app',
    component: App,
    beforeEnter(to, from, next) {
      // if(process.env.VUE_APP_MAINTENANCE === 'true') {
      //   next({
      //     name: 'maintenance'
      //   })
      // } else {
        if(!store.getters.isSalesforceAuthenticated) {
          next({
            name: 'salesforce-login'
          })
        } else {
          next();
        // }
      }
    }
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import('./components/Maintenance')
  },
  {
    path: '/login',
    name: 'salesforce-login',
    component: () => import('./components/SalesforceLogin')
  },
  {
    path: '/callback',
    name: 'salesforce-callback',
    component: () => import('./components/SalesforceCallback')
  },
  {
    path: '/filters',
    name: 'filters',
    component: () => import('./components/UsersAndFilters')
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('./components/Map')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
